import { call, all, takeEvery } from 'redux-saga/effects';
import { loadApp } from 'src/app/app-loading/app-loading-saga';
import { replaceSearchParamsInUrl } from 'src/dashboard/utils/replace-search-params-in-url';

import { DASHBOARD_UPGRADE_ACTIONS_TYPES } from './upgrade-actions';

const CHECKOUT = 'checkout';
const PICK_A_PLAN = 'pick-a-plan';

export function* handleOpenUpgradeModal() {
  const newParams = new URLSearchParams(window.location.search);
  newParams.set(CHECKOUT, PICK_A_PLAN);

  yield call(
    [window.history, 'pushState'],
    null,
    '',
    replaceSearchParamsInUrl(newParams)
  );
}

export function* handleCloseUpgradeModal() {
  const newParams = new URLSearchParams(window.location.search);
  newParams.delete(CHECKOUT);

  yield call(
    [window.history, 'replaceState'],
    null,
    '',
    replaceSearchParamsInUrl(newParams)
  );
}

export function* watchUpgradeModalSaga() {
  yield all([
    takeEvery(loadApp.type, handleCloseUpgradeModal),
    takeEvery(
      DASHBOARD_UPGRADE_ACTIONS_TYPES.upgradeModal.triggered,
      handleOpenUpgradeModal
    ),
    takeEvery(
      DASHBOARD_UPGRADE_ACTIONS_TYPES.upgradeModal.closed,
      handleCloseUpgradeModal
    ),
  ]);
}
